export default {
  all: '全部',
  back: '返回',
  searchResults: '搜索结果',
  searchPlaceholder: '搜索',
  apply: '应用筛选条件',
  clearAll: '清除全部',
  addResourceToPlayable: {
    editInfo: ['当前更新操作，没有选中节点', '游戏未加载'],
    editError: [
      '添加失败',
      '每个场景最多支持 4 个视频',
      '该资产已被删除，请重新选择',
    ],
  },
  audioList: {
    deleteError: '删除失败',
  },
  audioUploader: {
    localUpload: '本地上传',
    uploadRule: ['上传音效只能是', '格式!', '音频最大'],
    tips: '浏览所有资产',
    uploadRuleTips: {
      format: '音频文件格式',
      fileSize: '音频文件大小',
    },
  },
  deleteResource: {
    deleteError: '删除失败',
  },
  dialog: {
    image: '我的图片',
    aImage: '我的动图',
    xlz: '我的序列帧',
    text: '文字',
    video: '视频',
    audio: '我的音效',
    bgm: '我的背景音乐',
    particleEffect: '粒子库',
    assetLibrary: '我的资产库',
    tips: '只展示符合当前格式要求的资产',
  },
  imageUploader: {
    uploadRule: [
      '上传图片只能是',
      '格式!',
      '图片最大',
      '图片资源不允许超过xxx，请修改后重试',
    ],
    uploadRuleTips: {
      format: '图片文件格式',
      fileSize: '图片文件大小',
    },
  },
  resource: {
    noFoundError: '名称必须以数字结尾',
  },
  textList: {
    gameNotLoad: '游戏未加载',
  },
  videoUploader: {
    uploadRule: ['上传视频只能是', '格式!', '视频最大'],
    sceneSupport: '每个场景最多支持 4 个视频',
    uploadRuleTips: {
      format: '视频文件格式',
      fileSize: '视频文件大小',
    },
  },
  xlzUploader: {
    exceed: '单张图片最大',
    addXlzError: '添加序列帧失败，请稍后再试',
  },
  emptyNodeCategory: {
    label: '手势区域',
    text: '手势区域',
  },
  dragonBone: {
    required:
      '龙骨有且允许只有 **_ske.json、**_tex.json、**_tex.png 三个文件，** 必须一致',
  },
  categoryList: {
    commonLib: {
      label: '公共资源',
      text: '公共资源',
    },
    assetLib: {
      label: '我的资产库',
      text: '我的资产库',
    },
    resourcePool: {
      label: '资源库',
      text: '资源库',
    },
    image: {
      label: '图片',
      text: '图片',
      commonImage: '图片库',
    },
    aImage: {
      label: '动图',
      text: '动图',
      commonImage: '动图库',
    },
    video: {
      label: '视频',
      text: '视频',
    },
    audio: {
      label: '音效',
      text: '音效',
      commonAudio: '音效库',
    },
    text: {
      label: '文本',
      text: '文本',
    },
    bgm: {
      label: '背景音乐',
      text: '背景音乐',
      commonBgm: '背景音乐库',
    },
    effect: {
      label: '特效',
      text: '粒子',
      myEffect: '我的特效',
      xlzUploaderTitle: '上传序列帧',
      xlzUploaderTips: '选择多张图片上传',
      dragonUploaderTitle: '上传龙骨',
      dragonUploaderTips: '支持ZIP(json+png)格式',
      xlzTxt: '序列帧',
      particlesTxt: '粒子',
      dragonTxt: '龙骨',
    },
    scene: {
      label: '预设库',
      text: '预设库',
    },
    quickLayout: {
      label: '快捷排版',
      text: '快捷排版',
    },
    playUnit: {
      label: '玩法模板',
      text: '玩法模板',
    },
    widgetLib: {
      label: '组件库',
      text: '组件库',
    },
    globalVar: {
      label: '全局变量',
      text: '全局变量',
      addBtn: '+添加变量',
      addTitle: '新增变量',
      editTitle: '编辑变量',
      key: '名称',
      varType: '变量类型',
      initValue: '初始值',
      desc: '描述',
      keyPlaceholder: '请输入变量名称',
      varTypePlaceholder: '请选择数据类型',
      initValuePlaceholder: '请先选择变量类型',
      initNumberPlaceholder: '请输入初始数值',
      initStringPlaceholder: '请输入初始文本内容',
      initBooleanPlaceholder: '请选择初始值',
      descPlaceholder: '请输入描述(选填)',
      typeNumber: '数值',
      typeString: '文本',
      typeBoolean: '布尔值',
      typeGlobalVar: '全局变量',
      cancelBtn: '取消',
      saveBtn: '保存',
      confirmBtn: '确定',
      trueValue: 'true',
      falseValue: 'false',
      errorTip: '必填字段',
      errorTip2: '名称不能以数字开头',
      errorTip3: '已有重复名称的全局变量',
      errorTip4: 'playsmartGlobalVars是系统关键字',
      errorTip4_2: 'timers是系统关键字',
      errorTip5: '仅支持英文中文数字下划线，不能超过20个字符',
      errorTip6: '描述不能超过50个字符',
      deleteGlobalVarConfirm:
        '该全局变量已被引用到事件中，删除将会一并删除对应事件，是否确认删除？',
      globalVarWarning: '警告',
      editGlobalVarTypeConfirm:
        '该全局变量已被引用到事件中，修改变量类型将会删除对应事件，是否确认修改？',
      editGlobalVarKeyConfirm:
        '该全局变量已被引用到事件中，修改变量名称将会删除对应事件，是否确认修改？',
      noDataTip: '暂无数据',
      noDataTip2: '请点击按钮添加全局变量',
      conditionCompare: '条件判断',
      addConditionCompare: '+添加条件',
      globalVarKeyPlaceholder: '全局变量',
      compareTypePlaceholder: '类型',
      compareValuePlaceholder: '先选择类型',
      compareValueNumberPlaceholder: '数值',
      compareValueStringPlaceholder: '文本',
      compareValueBooleanPlaceholder: '布尔值',
      compareValueGlobalVarPlaceholder: '全局变量',
      compareTipIf: '如果',
      compareTipAnd: '并且',
      onlyOnce: '只生效一次',
      selectComputeMethod: '选择运算方法',
      deleteCompareWarning:
        '删除此条件判断将会同步删除对应响应事件，是否确认删除？',
    },
  },
  confirm: '确定',
  dragUpload: {
    note: '拖放文件即可立即上传',
    fileRequired: '支持的文件格式：png/jpg/mp3/mp4/龙骨zip(json+png)',
    namedRequired:
      '序列帧上传命名要求：爆炸1.png 爆炸2.png 爆炸3.png (逐帧提供)',
  },
  assetLib: {
    PublicAssetLib: '公共资产库',
    MyAssetLib: '我的资产库',
    image: '图片',
    gif: '动图',
    bgm: '背景音乐',
    soundEffect: '音效',
    particle: '粒子',
    video: '视频',
    audio: '音频',
  },
}
